import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Chip, Typography } from "@material-ui/core";
import { Page, PageContent, PageHeader } from "frame/components";
import NotFound from "./not-found";
import { ChildRoutes } from "./customer-routes";
import { CUSTOMERS_PATH } from "../actions/types";
import { useTerminology, useRouter } from "utils";
import SiteForm from "features/sites/components/site-form-container";
import { useDispatch } from "react-redux";
import { onAdd as onSiteAdd, onCustomerNameChanged } from "features/sites/actions";
import { onAdd as onJobAdd, onTypeChanged, onCustomerIdChanged } from "features/jobs/actions";
import { ADD_JOB_PATH } from "features/jobs/actions/types";

const useStyles = makeStyles((theme) => ({
	root: {},
	headerTitle: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(0.75),
		paddingBottom: theme.spacing(0.5),
	},
	headerRow: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "baseline",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	headerLabel: {
		color: "#999999",
		fontSize: theme.typography.pxToRem(13),
		fontWeight: theme.typography.fontWeightRegular,
		lineHeight: 1.4,
		flexShrink: 0,
	},
	headerValueLarge: {
		color: theme.palette.brand,
		fontSize: theme.typography.pxToRem(24),
		fontWeight: 700,
		lineHeight: 1.2,
		letterSpacing: "0.06px",
	},
	chipInactive: {
		backgroundColor: theme.palette.error.main,
		color: theme.palette.white,
	},
}));

const Customer = ({ customer }) => {
	const classes = useStyles();
	const { customersLabel, customerLabel } = useTerminology();
	const dispatch = useDispatch();
	const { history } = useRouter();

	const name = (customer && customer.customerName) || "Not Found";
	const inactive =
		customer && String(customer.status || "").toLowerCase() === "inactive";

	const onAddSite = () => {
		if (!customer?.id) {
			return;
		}
		dispatch(onSiteAdd());
		dispatch(onCustomerNameChanged(customer.id));
	};

	const onAddPhotoNote = () => {
		if (!customer?.id) {
			return;
		}
		dispatch(onJobAdd());
		dispatch(onTypeChanged("customer"));
		dispatch(onCustomerIdChanged(customer.id));
		history.push(ADD_JOB_PATH);
	};

	const pageTitle = (
		<div className={classes.headerTitle} data-cy="customer-detail-header">
			<div className={classes.headerRow}>
				<Typography
					component="span"
					className={classes.headerLabel}
					data-cy="customer-detail-label"
				>
					{customerLabel}
				</Typography>
				<Typography
					component="h1"
					className={classes.headerValueLarge}
					data-cy="customer-detail-name"
				>
					{name}
				</Typography>
				{inactive && (
					<Chip
						size="small"
						label="Inactive"
						className={classes.chipInactive}
						data-cy="customer-detail-status"
					/>
				)}
			</div>
		</div>
	);

	return (
		<Page className={classes.root} title={customersLabel}>
			<PageHeader title={pageTitle} />
			{customer ? (
				<PageContent>
					<ChildRoutes
						onAddSite={onAddSite}
						onAddPhotoNote={onAddPhotoNote}
					/>
					<SiteForm />
				</PageContent>
			) : (
				<PageContent pad>
					<NotFound />
				</PageContent>
			)}
		</Page>
	);
};

Customer.propTypes = {
	customer: PropTypes.object,
};

export default Customer;
